import Validator from 'validatorjs';

const 	composeValidators = (schema, values) => {
	let data = {},
			validation,
			customErrors = {}

	Object.keys(schema).map((item) => {
			if(schema[item] instanceof Function) {
				let errorFn = schema[item](values[item], values)

				if(errorFn != undefined)
					customErrors[item] = errorFn
			}else{
				if(values[item] != undefined)
					data[item] = values[item]
			}
	})
	
	validation = new Validator(data, schema);
	
	validation.passes();

	return {...validation.errors.errors, ...customErrors}
}
	
	
export default composeValidators